/* Breakz — what happens on a live break, published for the pixel.
 *
 * Shopify's own events cover the shop: a product viewed, a cart, a checkout,
 * a payment. They say nothing about a break, and a break is where this site
 * differs from a shop — someone arrives on the live page, presses play,
 * opens the chat, taps a team, and only then reaches checkout. Without these
 * four moments a report can show what was bought and never show how many
 * people were there to buy it.
 *
 * The events are published to the pixel manager with our own prefix. The
 * storefront may publish only its own events — "partners and merchants
 * cannot publish standard events" — so the names are breakz:live_*, never a
 * standard name. A pixel that subscribes receives them in event.customData;
 * a store with no pixel loses nothing, because publishing on its own sends
 * nothing anywhere.
 *
 * Consent is deliberately not checked here, exactly as in
 * breakz-search-analytics.js: publishing hands the data to the pixel
 * manager, and whether it travels further is the pixel's own consent
 * setting. Two places to decide the same thing would drift apart.
 *
 * No personal data: the break's handle, the product and variant ids, the
 * team's name — what was bought, never who bought it.
 *
 * Read from the markup:
 *   [data-lv-analytics]  the page's own record: break handle, its title,
 *                        whether the site is live, and which page this is
 *   [data-lv-play]       play pressed — breakz:live_play
 *   [data-lv-chat-open]  chat opened — breakz:live_chat
 *   [data-lv-buy]        a team or the random team tapped — breakz:live_spot
 * The page view itself is breakz:live_view, once per page.
 */
(() => {
  if (window.__breakzLiveAnalytics) return;
  window.__breakzLiveAnalytics = true;

  const root = document.querySelector('[data-lv-analytics]');
  if (!root) return;

  const base = () => ({
    page: root.dataset.lvAnalytics || 'live',
    break_handle: root.dataset.lvBreak || null,
    break_title: root.dataset.lvBreakTitle || null,
    live: root.dataset.lvLive === 'true',
  });

  const send = (name, data) => {
    const analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function') return;
    analytics.publish(name, Object.assign(base(), data || {}));
  };

  send('breakz:live_view', {});

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-lv-play]')) {
      send('breakz:live_play', {});
      return;
    }
    if (target.closest('[data-lv-chat-open]')) {
      send('breakz:live_chat', {});
      return;
    }
    const buy = target.closest('[data-lv-buy]');
    if (buy) {
      /* The gold button carries the random-team variant; a team button its
         own. The name comes from the button's text, which is the team. */
      send('breakz:live_spot', {
        variant_id: Number(buy.dataset.lvBuy) || null,
        product_id: Number(root.dataset.lvProduct) || null,
        team: (buy.querySelector('.lv-spot-name, .sp-team-name') || buy.querySelector('.lv-cta-text, .sp-cta-text') || buy).textContent.trim().slice(0, 60),
        random: buy.classList.contains('lv-cta') || buy.classList.contains('sp-cta'),
      });
    }
  });
})();
